import { showErrorMessage } from "../commons/show-error-message";
import { deleteRecurrentSubsidy } from "../../infrastructure/repository/benefit-models-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { showSuccessMessage } from "../commons/show-success-message";
// import { displayBenefitPage } from '../benefit-model/displays/display-benefit-page';
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function removeRecurrentSubsidy(model) {
  try {
    const companyId = await findCompanyId();

    await deleteRecurrentSubsidy(companyId, model);
    // displayBenefitPage(model);
    // TODO: Delete reload!
    window.location.reload();

    addContextLog("info", "deleteRecurrentSubsidy", "request", {
      companyId,
      model: model.id,
    });
    showSuccessMessage("Borrado con éxito");
  } catch (e) {
    logError(e, `Error to removeRecurrentSubsidy in model ${model.id}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
